import React, { useState, useEffect } from "react";
import CopyButton from "./CopyButton";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { BsInfoCircle } from "react-icons/bs";

const ReferenceGenerator = ({ onReferenceGenerated }) => {
  const [ref, setRef] = useState("");
  const [isGenerated, setIsGenerated] = useState(false);

  useEffect(() => {
    const storedRef = localStorage.getItem("ref_generated_once");
    if (storedRef) {
      setRef(storedRef);
      setIsGenerated(true);
      onReferenceGenerated?.(storedRef);
    }
  }, []);

  const generateRef = () => {
    if (isGenerated) return;

    const randomNum = Math.floor(100000 + Math.random() * 900000);
    const newRef = `BID-WIRE-${randomNum}`;
    setRef(newRef);
    setIsGenerated(true);
    localStorage.setItem("ref_generated_once", newRef);
    onReferenceGenerated?.(newRef);
  };

  return (
    <div className="mt-6">
      <div className="flex justify-between items-center mb-3 px-2">
        <div className="flex items-center gap-1 text-gray-700 font-semibold">
          <span>Generate Ref ID:</span>
          <span data-tooltip-id="ref-id-tooltip" className="cursor-pointer">
            <BsInfoCircle className="text-gray-400 text-base" />
          </span>
        </div>

        <button
          onClick={generateRef}
          disabled={isGenerated}
          className="px-4 py-1 bg-primary-red text-white rounded hover:bg-primary-red/90 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Generate
        </button>
      </div>

      {isGenerated && (
        <>
          <p className="text-xs text-center text-red-600 mb-2">
            To generate a new Ref ID, please save or complete this one first.
          </p>
          <p className="text-xs text-center text-red-500 mt-1 mb-2">
            No worries! If you want to complete the wire transfer later, your
            reference code will still be here when you return.
          </p>
        </>
      )}

      {ref && (
        <div className="flex justify-center">
          <div className="flex items-center gap-2 px-3 py-2 bg-gray-100 border border-gray-300 rounded-md text-sm text-gray-800">
            <CopyButton valueToCopy={ref} />
            <span>{ref}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReferenceGenerator;
